import AmplitudeProvider from "~/AmplitudeProvider";

export interface OrderEvent {
  asset_symbol?: string;
  asset_class?: "us_equity" | "us_option" | "crypto";
  is_notional?: boolean;
  qty?: string | number;
  amount?: string | number;
  order_type?: string;
  time_in_force?: string;
}

export const amplitudeTradeTracking = {
  optionsTabClicked: () =>
    AmplitudeProvider.dispatch("algodash_options_tab_clicked", {
      url: window?.location?.pathname,
    }),
  optionsCallsPutsClicked: (side: "call" | "put" | "calls & puts") =>
    AmplitudeProvider.dispatch("algodash_options_calls_puts_clicked", {
      url: window?.location?.pathname,
      side,
    }),
  optionsExpirationClicked: (expiration: string) =>
    AmplitudeProvider.dispatch("algodash_options_expiration_clicked", {
      url: window?.location?.pathname,
      expiration,
    }),
  optionsContractClicked: (contract: string, type?: string) =>
    AmplitudeProvider.dispatch("algodash_options_contract_clicked", {
      url: window?.location?.pathname,
      contract,
      type,
    }),
  optionsContractBackClicked: (contract: string) =>
    AmplitudeProvider.dispatch("algodash_options_contract_back_clicked", {
      url: window?.location?.pathname,
      contract,
    }),
  orderTypeChanged: (orderType: string) =>
    AmplitudeProvider.dispatch("algodash_quicktrade_order_type_clicked", {
      order_type: orderType,
      url: window?.location?.pathname,
    }),
  positionIntentChanged: (positionIntent: string, orderEvent: OrderEvent) =>
    AmplitudeProvider.dispatch("algodash_options_position_intent_changed", {
      position_intent: positionIntent,
      ...orderEvent,
      url: window?.location?.pathname,
    }),
  quantityChanged: (qty: number | string) =>
    AmplitudeProvider.dispatch("qty_on_asset_page_inputted", { qty }),
  reviewOrderClicked: (orderEvent: OrderEvent) =>
    AmplitudeProvider.dispatch("review_order_on_asset_page_clicked", {
      ...orderEvent,
    }),
  confirmOrderClicked: (orderEvent: OrderEvent) =>
    AmplitudeProvider.dispatch("confirm_order_on_asset_page_clicked", {
      ...orderEvent,
    }),
};
